// @react-native-async-storage/async-storage resolves to its native build on
// web (NativeModules.RNCAsyncStorage = null), so redux-persist never rehydrates
// and PersistGate holds null forever. Back it with localStorage — same async
// contract, persists across reloads. (Phase 2 could swap in IndexedDB for size.)
// eslint-disable-next-line @typescript-eslint/no-require-imports
const { checkWebBuild, clearWebBuild } = require("./web-build");
const mem = {};
const ls = (() => {
  try {
    window.localStorage.setItem("__t", "1");
    window.localStorage.removeItem("__t");
    return window.localStorage;
  } catch (_) {
    return {
      getItem: (k) => (k in mem ? mem[k] : null),
      setItem: (k, v) => {
        mem[k] = v;
      },
      removeItem: (k) => {
        delete mem[k];
      },
      key: (i) => Object.keys(mem)[i],
      get length() {
        return Object.keys(mem).length;
      },
    };
  }
})();

const AsyncStorage = {
  getItem: (k) => Promise.resolve(ls.getItem(k)),
  setItem: (k, v) => {
    const r = Promise.resolve(ls.setItem(k, v));
    // D+ per-CP web build routing: a fresh login token → ask which build to run.
    if (k === "user_token") {
      if (v) checkWebBuild(String(v));
      else clearWebBuild();
    }
    return r;
  },
  removeItem: (k) => {
    const r = Promise.resolve(ls.removeItem(k));
    if (k === "user_token") clearWebBuild(); // logout → drop the build cookies
    return r;
  },
  clear: () => Promise.resolve(ls.clear && ls.clear()),
  getAllKeys: () =>
    Promise.resolve(
      Object.keys({ length: ls.length }).length
        ? Array.from({ length: ls.length }, (_, i) => ls.key(i))
        : [],
    ),
  multiGet: (keys) => Promise.resolve(keys.map((k) => [k, ls.getItem(k)])),
  multiSet: (pairs) =>
    Promise.resolve(pairs.forEach(([k, v]) => ls.setItem(k, v))),
  multiRemove: (keys) => Promise.resolve(keys.forEach((k) => ls.removeItem(k))),
  mergeItem: (k, v) => Promise.resolve(ls.setItem(k, v)),
  flushGetRequests: () => {},
};

module.exports = AsyncStorage;
module.exports.default = AsyncStorage;
